import {
  Activity,
  ArrowUpDown,
  BarChart3,
  ChevronDown,
  CircleGauge,
  DatabaseZap,
  Languages,
  Menu,
  SearchCheck,
  TrendingUp,
  X
} from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "wouter";
import { isDemoMode } from "../lib/api";

const nav = [
  { path: "/", key: "overview", icon: CircleGauge },
  { path: "/rankings", key: "rankings", icon: TrendingUp },
  { path: "/traffic", key: "traffic", icon: BarChart3 },
  { path: "/ranking-traffic", key: "matrix", icon: SearchCheck },
  { path: "/movers", key: "movers", icon: ArrowUpDown },
  { path: "/sync", key: "sync", icon: DatabaseZap }
];

export function Shell({ children }: { children: React.ReactNode }) {
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [location] = useLocation();
  const language = i18n.language.startsWith("en") ? "en" : "vi";

  const switchLanguage = () => {
    const next = language === "vi" ? "en" : "vi";
    void i18n.changeLanguage(next);
    localStorage.setItem("agrowth-language", next);
  };

  return (
    <div className="app-shell">
      <aside className={menuOpen ? "sidebar open" : "sidebar"}>
        <div className="brand">
          <div className="brand-mark">
            <Activity size={20} />
          </div>
          <div>
            <strong>AGROWTH</strong>
            <span>{t("product")}</span>
          </div>
          <button className="mobile-close" onClick={() => setMenuOpen(false)} type="button">
            <X size={20} />
          </button>
        </div>
        <nav>
          <span className="nav-label">Workspace</span>
          {nav.map(({ path, key, icon: Icon }) => {
            const isActive = path === "/" ? location === "/" : location.startsWith(path);
            return (
            <Link
              key={key}
              href={path}
              onClick={() => setMenuOpen(false)}
              className={isActive ? "active" : ""}
            >
              <Icon size={18} />
              <span>{t(`nav.${key}`)}</span>
              <i />
            </Link>
          )})}
        </nav>
        <div className="sidebar-footer">
          <div className="data-source">
            <span className="status-dot" />
            <div>
              <strong>{isDemoMode ? t("demoData") : t("liveData")}</strong>
              <small>SERPRobot + GSC</small>
            </div>
          </div>
          <button type="button" className="account">
            <span>AG</span>
            <div>
              <strong>Agrowth Team</strong>
              <small>agrowth.io</small>
            </div>
            <ChevronDown size={15} />
          </button>
        </div>
      </aside>
      {menuOpen && <button className="backdrop" onClick={() => setMenuOpen(false)} />}
      <main>
        <header className="topbar">
          <button className="menu-button" onClick={() => setMenuOpen(true)} type="button">
            <Menu size={21} />
          </button>
          <div className="topbar-context">
            <span>agrowth.io</span>
            <i>/</i>
            <strong>{t("product")}</strong>
          </div>
          <div className="topbar-actions">
            <span className={`environment-pill ${isDemoMode ? "demo" : ""}`}>
              <span />
              {isDemoMode ? t("demoData") : t("liveData")}
            </span>
            <button className="language-button" onClick={switchLanguage} type="button">
              <Languages size={17} />
              {language.toUpperCase()}
            </button>
          </div>
        </header>
        <div className="page-content">{children}</div>
      </main>
    </div>
  );
}
